import { SDUIBannerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/SDUIBannerRenderer";
import { SDUICarouselRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Carousel/SDUICarouselRenderer";
import { SDUIFilterRowRendererRSC } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/FilterBar/SDUIFilterRowRendererRSC";
import { SDUIGridV2Renderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/SDUIGridV2Renderer";
import { SDUIHeaderRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Header/SDUIHeaderRenderer";
import { SDUICategoryPageLayoutElementRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/LayoutElement/SDUICategoryPageLayoutElementRenderer";
import { SDUISpacerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Spacer/SDUISpacerRenderer";
import { SDUITileWrapperComponentRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/TileWrapper/SDUITileWrapperComponentRenderer";
import { BannerLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/LoadingRenderers/Components/BannerLoadingSkeleton";
import { CarouselLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/LoadingRenderers/Components/CarouselLoadingSkeleton";
import { ProductTileLoadingSkeleton } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileLoadingSkeleton";
export var hubComponentRenderers = {
    layout_element: {
        active: SDUICategoryPageLayoutElementRenderer,
        pending: CarouselLoadingSkeleton
    },
    carousel_component: {
        active: SDUICarouselRenderer,
        pending: CarouselLoadingSkeleton
    },
    banner_component: {
        active: SDUIBannerRenderer,
        pending: BannerLoadingSkeleton
    },
    spacer_component: {
        active: SDUISpacerRenderer
    },
    header_component: {
        active: SDUIHeaderRenderer
    },
    grid_component: {
        active: SDUIGridV2Renderer
    },
    tile_wrapper_component: {
        active: SDUITileWrapperComponentRenderer,
        pending: ProductTileLoadingSkeleton
    },
    filter_bar_component: {
        active: SDUIFilterRowRendererRSC
    }
};
